import { setLocalTokens } from '../actions/tokens';
import setTokensOnLocalStorage from './setTokensOnLocalStorage';

const createSimulateExpiredToken =
  ({ getState, dispatch }) =>
  ({ access = true, refresh = false } = {}) => {
    try {
      // Clone tokens
      const tokens = JSON.parse(JSON.stringify(getState().tokens));

      if (access) {
        tokens.access.valid_until = 0;
      }
      if (refresh) {
        tokens.refresh.valid_until = 0;
      }

      setTokensOnLocalStorage(tokens);
      dispatch(setLocalTokens(tokens));
    } catch (e) {
      // Ignore
    }
  };

export default createSimulateExpiredToken;
